/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesMemberFieldTypes } from './WebApiModelsEnumerationTypesMemberFieldTypes';
import {
    WebApiModelsEnumerationTypesMemberFieldTypesFromJSON,
    WebApiModelsEnumerationTypesMemberFieldTypesFromJSONTyped,
    WebApiModelsEnumerationTypesMemberFieldTypesToJSON,
} from './WebApiModelsEnumerationTypesMemberFieldTypes';

/**
 * 
 * @export
 * @interface WebApiPublicSiteDtoPublicViewColumnDto
 */
export interface WebApiPublicSiteDtoPublicViewColumnDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiPublicSiteDtoPublicViewColumnDto
     */
    sortOrder?: number;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMemberFieldTypes}
     * @memberof WebApiPublicSiteDtoPublicViewColumnDto
     */
    columnType?: WebApiModelsEnumerationTypesMemberFieldTypes;
    /**
     * 
     * @type {number}
     * @memberof WebApiPublicSiteDtoPublicViewColumnDto
     */
    customFieldId?: number | null;
}

/**
 * Check if a given object implements the WebApiPublicSiteDtoPublicViewColumnDto interface.
 */
export function instanceOfWebApiPublicSiteDtoPublicViewColumnDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPublicSiteDtoPublicViewColumnDtoFromJSON(json: any): WebApiPublicSiteDtoPublicViewColumnDto {
    return WebApiPublicSiteDtoPublicViewColumnDtoFromJSONTyped(json, false);
}

export function WebApiPublicSiteDtoPublicViewColumnDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPublicSiteDtoPublicViewColumnDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sortOrder': !exists(json, 'sortOrder') ? undefined : json['sortOrder'],
        'columnType': !exists(json, 'columnType') ? undefined : WebApiModelsEnumerationTypesMemberFieldTypesFromJSON(json['columnType']),
        'customFieldId': !exists(json, 'customFieldId') ? undefined : json['customFieldId'],
    };
}

export function WebApiPublicSiteDtoPublicViewColumnDtoToJSON(value?: WebApiPublicSiteDtoPublicViewColumnDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sortOrder': value.sortOrder,
        'columnType': WebApiModelsEnumerationTypesMemberFieldTypesToJSON(value.columnType),
        'customFieldId': value.customFieldId,
    };
}

